import { render, staticRenderFns } from "./ContactInfoNuera.vue?vue&type=template&id=2d8a4de0&scoped=true&"
import script from "./ContactInfoNuera.vue?vue&type=script&lang=js&"
export * from "./ContactInfoNuera.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoNuera.vue?vue&type=style&index=0&id=2d8a4de0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8a4de0",
  null
  
)

export default component.exports